import type { CSSObject } from '@emotion/react'
import {
  Color,
  FontWeight,
  Shadow,
  ShadowElevation,
  Spacing,
} from '@opallabs/gem'
import { PlaceholderColor } from '../../../types'
import { lookupPlaceholderHex } from '../lookupPlaceholderHex'

const CARD_RADIUS = 8

const base: CSSObject = {
  borderRadius: CARD_RADIUS,
  marginBlockEnd: Spacing.M,
  ...Shadow[ShadowElevation.E1],
}

/**
 * We have some lingering global textarea styles that have a higher
 * specificity than emotion outputs by default. Using !important
 * here to ensure we are overriding those styles without needing
 * to apply unncessary selectors like `:not(.styled)`.
 */
const textarea = (placeholderColor: PlaceholderColor): CSSObject => ({
  backgroundColor: `${lookupPlaceholderHex(placeholderColor)} !important`,
  color: `${Color.light.Text.Default} !important`,
  borderRadius: `${CARD_RADIUS}px ${CARD_RADIUS}px 0 0 !important`,
  fontWeight: FontWeight.Bold,
  blockSize: Spacing.XS * 11,
  lineHeight: '20px',
  padding: Spacing.XS,
  '&::placeholder': {
    fontWeight: FontWeight.Bold,
    color: Color.light.Text.Default,
  },
  '&:focus': {
    border: `solid 1px ${Color.light.Surface.A000}`,
  },
})

const cardBody = (placeholderColor: PlaceholderColor): CSSObject => ({
  borderRadius: CARD_RADIUS,
  backgroundColor: lookupPlaceholderHex(placeholderColor),
  '.kuiper-loader-container': {
    borderRadius: `${CARD_RADIUS}px ${CARD_RADIUS}px 0 0`,
  },
})

const cardFooter: CSSObject = {
  borderBottomLeftRadius: CARD_RADIUS,
  borderBottomRightRadius: CARD_RADIUS,
  borderTop: `solid 1px ${Color.light.Surface.N300}`,
  padding: Spacing.S,
  position: 'relative',
  backgroundColor: '#f7f8fa',
}

export const styles = {
  base,
  cardBody,
  cardFooter,
  textarea,
}
